<template>
  <div class="attachments">
    <div class="info">
      <small class="textGray">{{ attachmentsList.length }} anexos</small>
      <button
        class="btn btn-secondary float-right"
        data-toggle="modal"
        data-target=".modal-anexo"
      >
        Anexar novo
      </button>
      <button
        v-if="linkRoute"
        class="btn btn-secondary float-right"
        data-toggle="modal"
        data-target=".modal-files"
        style="margin-right: 8px"
        v-on:click="getFolders"
      >
        Selecionar do arquivo
      </button>
      <!-- <button
        class="btn btn-secondary float-right"
        data-toggle="modal"
        data-target=".modal-link"
        style="margin-right: 8px"
      >ADICIONAR LINK</button>-->
    </div>

    <div
      class="modal fade modal-anexo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <div class=".col-md-6 .ml-auto">
              <h5>Anexar Arquivo</h5>
            </div>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <b-form-file
                  placeholder="Escolha um arquivo"
                  drop-placeholder="Arraste o arquivo aqui..."
                  browse-text="Procurar"
                  accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                  v-on:change="newAttachment"
                  v-model="attachment"
                ></b-form-file>
                <small v-if="typeDocument === 'security_validation'" class="form-text text-muted">
                  Formatos incluídos no PDF do DVS: PDF, JPG/JPEG e PNG.
                </small>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="attachment_title"
                  placeholder="Título"
                />
              </div>
            </form>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-success"
                data-dismiss="modal"
                v-on:click="saveAttachment()"
              >
                <span>Salvar <font-awesome-icon icon="save" /> </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade modal-files"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <div class=".col-md-6 .ml-auto">
              <h5>Selecionar Arquivo</h5>
            </div>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row" style="font-size: 18px; margin-bottom: 8px">
                <div class="col-6">
                  <font-awesome-icon
                    style="margin-right: 8px; color: #f2671c"
                    icon="folder-open"
                  />
                  <span>{{ folder.name ? folder.name : "Diretórios" }}</span>
                </div>
                <div class="col-6">
                  <div class="w-100 d-flex justify-content-end">
                    <div
                      class="return"
                      v-if="folder.id"
                      v-on:click="
                        openFolder(
                          folder.ancestor ? folder.ancestor.id : 'root'
                        )
                      "
                    >
                      <font-awesome-icon icon="angle-left" />Voltar
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row"
                style="max-height: 60vh; overflow: auto"
                v-if="renderFolders"
              >
                <div
                  class="col-12"
                  v-for="subFolder in folder.descendants"
                  v-bind:key="subFolder.id"
                  v-on:click="openFolder(subFolder.id)"
                >
                  <FolderItem
                    type="folder"
                    :name="subFolder.name"
                    :id="subFolder.id"
                  ></FolderItem>
                </div>
                <div
                  class="col-12"
                  v-for="file in folder.attachments"
                  v-bind:key="file.id"
                >
                  <FolderItem
                    type="file"
                    :name="file.name"
                    :size="formatNumber(file.size / 1000) + 'KB'"
                    :id="file.id"
                    :url="file.url"
                    canSelect
                    :selected="isSelectedItem(file.id)"
                    @selectItem="selectItem"
                  ></FolderItem>
                </div>
              </div>
              <div
                v-if="!renderFolders"
                class="w-100 d-flex justify-content-center align-items-center"
                style="margin-top: 30px; margin-bottom: 30px"
              >
                <b-spinner
                  style="margin-right: 15px"
                  label="Small Spinner"
                ></b-spinner>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-success"
                data-dismiss="modal"
                v-on:click="linkAttachments()"
              >
                <span>Salvar <font-awesome-icon icon="save" /> </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="attachmentsList">
      <div
        class="attachment"
        v-for="(item, index) in attachmentsList"
        v-bind:key="index"
      >
        <div class="name">{{ item.title || item.name || "Sem Título" }}</div>
        <div class="info">
          <div class="date textGray mr-3">
            anexado em
            <br />
            {{ formatDate(item.created_at) }}
          </div>
        </div>
        <div class="textGray" v-if="item.url && item.size">
          <span v-if="(item.size / 1000000).toFixed(2) >= 1">{{
            (item.size / 1000000).toFixed(2) + "MB"
          }}</span>
          <span v-else>{{ (item.size / 1000).toFixed(2) + "KB" }}</span>
        </div>
        <div class="ml-3">
          <a :href="item.url" target="_blank">
            <button class="btn btn-success ml-2">
              <font-awesome-icon
                style="color: white"
                icon="external-link-alt"
              />
            </button>
          </a>
        </div>
        <div class="ml-3" v-if="item.isFromDirectory">
          <button
            class="btn btn-danger"
            v-on:click="
              openModalAttachmentFromDirectoryToDelete(
                'confirm-modal-from-directory',
                item,
                index
              )
            "
            style="min-width: 40px"
          >
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <div class="ml-3" v-else>
          <button
            class="btn btn-danger"
            type="button"
            v-on:click="openModalAttachmentToDelete('confirm-modal', item, index)"
            v-if="canAccess()"
          >
            <font-awesome-icon icon="trash" />
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="adding"
      class="savingContent w-100 d-flex justify-content-end align-items-center"
      style="margin-top: 30px"
    >
      <b-spinner style="margin-right: 15px" label="Small Spinner"></b-spinner>
      <span>Adionando anexo</span>
    </div>

    <b-modal
      ref="confirm-modal"
      title="Remover Anexo"
      modal-ok="Confirmar"
      modal-cancel="Cancelar"
      @ok="removeAttachment()"
    >
      Deseja mesmo remover o anexo:
      {{ attachmentToDelete.title || attachmentToDelete.name }}
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>

    <b-modal
      ref="confirm-modal-from-directory"
      title="Remover Anexo"
      modal-ok="Confirmar"
      modal-cancel="Cancelar"
      @ok="removeAttachmentFromDocument()"
    >
      Deseja mesmo remover o anexo: {{ attachmentFromDirectoryToDelete.name }}
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>
  </div>
</template>
<script>
import axios from "@/api/axios";
import FolderItem from "@/components/FolderItem.vue";
import { canAccess } from "@/utils/canAccess";
import moment from "moment";

// Documentos que aceitam vincular arquivos já cadastrados nos diretórios:
// tipo do documento -> trecho da rota .../{trecho}/{id}/attach-attachments-by-attach
const LINKABLE_DOCUMENT_ROUTES = {
  inventory: "inventories",
  security_validation: "security-validations",
  hazard_analysis: "hazard-analyses",
};

export default {
  name: "attachments",
  components: {
    FolderItem,
  },
  props: {
    document_id: String,
    typeDocument: String,
    company_id: String,
    machine_id: String,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      attachment: null,
      attachment_title: "",
      adding: false,
      attachmentsList: [],
      folder: {},
      renderFolders: true,
      existsAttachmentList: [],
      attachmentFromDirectoryToDelete: {},
      attachmentToDelete: {},
      attachmentIndexToDelete: null,
    };
  },
  computed: {
    linkRoute() {
      return LINKABLE_DOCUMENT_ROUTES[this.typeDocument];
    },
  },
  mounted() {
    this.getAttachments();
  },
  methods: {
    canAccess,
    getAttachments: function () {
      const loader = this.$loading.show();
      axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/get-attachments-document/`,
          {
            document_id: this.document_id,
            document_type: this.typeDocument,
          }
        )
        .then((response) => {
          this.attachmentsList = [];
          this.attachmentsList = [...response.data];
          loader.hide();
        })
        .catch(() => {});
    },
    convertBase64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    newAttachment: async function (e) {
      const file = e.target.files && e.target.files[0];
      if (!file) {
        this.attachment = null;
        return;
      }

      if (this.typeDocument === 'security_validation' && !this.isSupportedDvsAttachment(file)) {
        this.attachment = null;
        e.target.value = '';
        this.$bvToast.toast(
          `O arquivo "${file.name}" não pode ser anexado ao DVS. Converta-o para PDF, JPG/JPEG ou PNG.`,
          {
            title: 'Formato não aceito',
            toaster: 'b-toaster-top-right',
            solid: true,
            variant: 'warning',
          }
        );
        return;
      }

      const response = await this.convertBase64(file);
      this.attachment = { file: response, name: file.name };
    },
    isSupportedDvsAttachment(file) {
      return ['application/pdf', 'image/jpeg', 'image/png'].includes(file.type);
    },
    removeAttachment: function () {
     const loader = this.$loading.show();
      axios
        .delete(
          `${process.env.VUE_APP_API_HOST}/api/admin/attachments/${this.attachmentToDelete.id}`
        )
        .then(() => {
          this.attachmentsList.splice(this.attachmentIndexToDelete, 1);
          (this.attachmentToDelete = {}), loader.hide();
        })
        .catch(() => {
          loader.hide();
        });
    },
    removeAttachmentFromDocument: function () {
      const loader = this.$loading.show();
      axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/delete-attachments-to-document/${this.attachmentFromDirectoryToDelete.id}`,
          {
            attachment_id: this.attachmentFromDirectoryToDelete.id,
            document_id: this.document_id,
            document_type: this.typeDocument,
          }
        )
        .then(() => {
          this.attachmentsList.splice(this.attachmentIndexToDelete, 1);
          (this.attachmentFromDirectoryToDelete = {}), loader.hide();
        })
        .catch(() => {
          loader.hide();
        });
    },
    saveAttachment: function () {
      if (!this.attachment || !this.attachment.file) {
        this.$bvToast.toast('Selecione um arquivo PDF, JPG/JPEG ou PNG.', {
          title: 'Anexo obrigatório',
          toaster: 'b-toaster-top-right',
          solid: true,
          variant: 'warning',
        });
        return;
      }

      this.uploadAttachment(
        this.attachment.file,
        this.attachment.name,
        this.attachment_title
      );
    },
    uploadAttachment: function (base64, fileName) {
      let x = base64.split(",");
      const loader = this.$loading.show();
      axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/attachments-to-document/`,
          {
            document_id: this.document_id,
            document_type: this.typeDocument,
            company_id: this.company_id,
            file: x[1],
            name: fileName,
            title: this.attachment_title,
            machine_id: this.machine_id,
          }
        )
        .then(() => {
          this.adding = false;
          this.getAttachments();
          this.attachment = null;
          this.attachment_title = "";
          this.attachment_file = null;
          this.attachment_name = "";
          loader.hide();
        })
        .catch((error) => {
          this.adding = false;
          loader.hide();
          this.$bvToast.toast(
            error.response?.data?.message || 'Não foi possível anexar o arquivo.',
            {
              title: 'Erro no anexo',
              toaster: 'b-toaster-top-right',
              solid: true,
              variant: 'danger',
            }
          );
        });
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },

    getFolders: function () {
      // this.loader = this.callLoader();
      this.renderFolders = false;
      let url = this.machine_id
        ? `${process.env.VUE_APP_API_HOST}/api/admin/directories?filter[machine_id]=${this.machine_id}&filter[where_is_root]=1`
        : `${process.env.VUE_APP_API_HOST}/api/admin/directories?filter[company_id]=${this.company_id}&filter[where_is_root]=1`;
        
      axios
        .get(url, {
          params: {
            page: 1,
            per_page: 100,
          },
        })
        .then((response) => {
          this.folder.descendants = response.data.data;
          this.folder.attachments = [];
          this.renderFolders = true;
        })
        .catch(() => {
          this.renderFolders = true;
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger",
            }
          );
          // this.loader.hide();
        });
    },
    openFolder: function (folder_id) {
      if (folder_id == "root") {
        this.folder = {};
        return this.getFolders();
      }
      // this.loader = this.callLoader();
      this.renderFolders = false;
      axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/get-attachments-by-machine`,
          { directory_id: folder_id, machine_id: this.machine_id }
        )
        .then((response) => {
          this.folder = response.data;
          this.renderFolders = true;
          // this.loader.hide();
        })
        .catch(() => {
          this.renderFolders = true;
          this.$bvToast.toast(
            `Desculpe, tivemos algum problema. Por favor tente novamente!`,
            {
              title: `Ocorreu um erro`,
              toaster: "b-toaster-top-center",
              solid: true,
              variant: "danger",
            }
          );
          // this.loader.hide();
        });
    },
    formatNumber(n) {
      let t = parseFloat(n).toFixed(1);
      return t.replace(".", ",");
    },
    selectItem(id, value) {
      if (value) {
        this.existsAttachmentList.push(id);
      } else {
        let index = this.existsAttachmentList.indexOf(id);
        this.existsAttachmentList.splice(index, 1);
      }
    },
    isSelectedItem(id) {
      return this.existsAttachmentList.indexOf(id) >= 0;
    },
    openModalAttachmentFromDirectoryToDelete: function (modal, item, index) {
      this.attachmentFromDirectoryToDelete = item;
      this.attachmentIndexToDelete = index;
      this.$refs[modal].show();
    },
    openModalAttachmentToDelete: function (modal, item, index) {
      this.attachmentToDelete = item;
      this.attachmentIndexToDelete = index;
      this.$refs[modal].show();
    },
    linkAttachments() {
      if (this.linkRoute && this.existsAttachmentList.length >= 1) {
        axios
          .post(
            `${process.env.VUE_APP_API_HOST}/api/admin/${this.linkRoute}/${this.document_id}/attach-attachments-by-attach`,
            {
              attachmentsByAttach: this.existsAttachmentList,
            }
          )
          .then(() => {
            this.getAttachments();
          })
          .catch((error) => {
            this.renderFolders = true;

            if (error.response.status == 400) {
              this.$bvToast.toast(
                error.response.data.error,
                {
                  title: `Ocorreu um erro`,
                  toaster: "b-toaster-top-center",
                  solid: true,
                  variant: "danger",
                }
              );
              this.existsAttachmentList = [];
            } else
              this.$bvToast.toast(
                `Desculpe, tivemos algum problema. Por favor tente novamente!`,
                {
                  title: `Ocorreu um erro`,
                  toaster: "b-toaster-top-center",
                  solid: true,
                  variant: "danger",
                }
              );
            // this.loader.hide();
          });
      }
    },
  },
};
</script>

<style lang="scss">
.return {
  margin-left: 4vw;
  svg {
    margin-right: 9px;
  }
}

.return:hover {
  cursor: pointer;
}
.attachments {
  margin-top: 2.5vh;
  .info {
    small {
      margin-left: 1.5vw;
    }
  }
  .attachmentsList {
    margin-top: 4.5vh;
    .attachment {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      padding: 12px 20px;
      border: 0.5px solid #e9eaee;
      border-radius: 5px;
      .name {
        min-width: 30%;
      }
      .info {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .date {
          font-size: 11px;
        }
      }
      .file {
        min-width: 7vw;
        margin-left: 2.5vw;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: fit-content;
        span {
          font-size: 14px;
          white-space: nowrap;
        }
      }
      .link {
        min-width: 7vw;
        margin-left: 2.5vw;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: fit-content;
      }
    }
  }
}
</style>
